import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ViewToggle = ({ view, onViewChange }) => {
  return (
    <div className="flex items-center bg-muted rounded-lg p-1">
      <Button
        variant={view === 'grid' ? 'default' : 'ghost'}
        size="sm"
        onClick={() => onViewChange('grid')}
        className="rounded-md"
      >
        <Icon name="Grid3X3" size={16} />
        <span className="ml-2 hidden sm:inline">Grade</span>
      </Button>
      
      <Button
        variant={view === 'list' ? 'default' : 'ghost'}
        size="sm"
        onClick={() => onViewChange('list')}
        className="rounded-md"
      >
        <Icon name="List" size={16} />
        <span className="ml-2 hidden sm:inline">Lista</span>
      </Button>
    </div>
  );
};

export default ViewToggle;